import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue, handleDateChangeEvent } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';

class NewCarKmHistory extends Component {

    state = {
        licenseNumber: this.props.row.licenseNumber,
        carId: this.props.row.privateId,
        km: '',
        date: new Date(),
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/carkm';
        const requestObject = {
            "carId": this.state.carId,
            "licenseNumber": this.state.licenseNumber,
            "km": trimSpaces(this.state.km),
            "date": this.state.date
        };
        console.log(requestObject);
        await handlePost(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            id="date"
                            name="date"
                            label="Km dátuma"
                            errors={this.state.errors}
                            value={this.state.date}
                            onChange={v => handleDateChangeEvent(v, "date", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            name="km"
                            label="Kilóméteróra állás"
                            errors={this.state.errors}
                            value={this.state.km}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewCarKmHistory);
